export interface IPaginate {
  page: number;
  pageCount: number;
  start: number;
  end: number;
  count: number;
}

export class PaginateDTO implements IPaginate {
  public page = 0;
  public pageCount = 0;
  public start = 0;
  public end = 0;
  public count = 0;
}

export default class PaginateModel extends PaginateDTO {
  constructor(dto: PaginateDTO) {
    super();
    Object.assign(this, dto);
  }
}
